import { create } from 'zustand';

import { pb } from '@/core/api';

import type { RecordModel } from 'pocketbase';

type AuthState = {
  user: RecordModel | null;
  isAuthenticated: boolean;
  isLoading: boolean;
};

type AuthActions = {
  initialize: () => void;
  login: (email: string, password: string) => Promise<void>;
  register: (email: string, password: string) => Promise<void>;
  logout: () => void;
};

async function createUserWithSettings(
  email: string,
  password: string
): Promise<void> {
  await pb
    .collection('users')
    .create({ email, password, passwordConfirm: password });
  await pb.collection('users').authWithPassword(email, password);
  await pb.collection('user_settings').create({
    user: pb.authStore.model?.id,
    key: 'monitoring_active',
    value: 'true',
  });
}

type SetFn = (state: Partial<AuthState>) => void;

function initializeAuth(set: SetFn): void {
  set({
    user: pb.authStore.model,
    isAuthenticated: pb.authStore.isValid,
    isLoading: false,
  });
  pb.authStore.onChange((_, model) => {
    set({ user: model, isAuthenticated: pb.authStore.isValid });
  });
}

export const useAuthStore = create<AuthState & AuthActions>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  initialize: (): void => initializeAuth(set),
  login: async (email, password): Promise<void> => {
    await pb.collection('users').authWithPassword(email, password);
  },
  register: createUserWithSettings,
  logout: (): void => pb.authStore.clear(),
}));
